import React from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Box, Typography, Grid, Button } from '@material-ui/core'

import { SelectPaymentMethod } from 'componentsCheckout'
import { DynamicInputField } from 'components/ComponentsTextField'

import constants from 'constants/index'

import schema from './schema'

const CustomerForm = ({ setStep, setCustomer, type, components }) => {
  const { control, handleSubmit, errors, setValue } = useForm({
    validationSchema: schema,
    defaultValues: {
      paymentMethod: '',
      name: '',
      email: '',
      document: '',
      documentType: '',
      birthDate: '',
      address: {
        street: '',
        number: '',
        neighborhood: '',
        city: '',
        state: '',
        postalCode: '',
      },
    },
  })

  const formatCustomerParams = (data) => {
    return {
      name: data?.name,
      email: data?.email,
      document: data?.document,
      documentType: data?.documentType,
      birthDate: data?.birthDate,
      address: {
        street: data?.address?.street,
        number: data?.address?.number,
        neighborhood: data?.address?.neighborhood,
        city: data?.address?.city,
        state: data?.address?.state,
        postalCode: data?.address?.postalCode,
      },
    }
  }

  const determineDocumentType = (document) => {
    if (!document) return ''

    // Remove caracteres especiais para contar apenas os números
    const cleanDocument = document.replace(/\D/g, '')

    if (cleanDocument.length === 11) {
      return 'CPF'
    } else if (cleanDocument.length === 14) {
      return 'CNPJ'
    }

    return ''
  }

  const onSubmit = (data) => {
    // Se não houver `birthDate`, defina um valor padrão de 01/01/2000
    if (!data.birthDate) {
      const defaultDate = '2000-01-01' // Data padrão 01/01/2000 no formato YYYY-MM-DD
      setValue('birthDate', defaultDate)
      data.birthDate = defaultDate
    }

    // Determina e preenche o documentType baseado no documento
    const documentType = determineDocumentType(data.document)
    if (documentType) {
      setValue('documentType', documentType)
      data.documentType = documentType
    }

    setStep(data.paymentMethod)
    setCustomer(formatCustomerParams(data))
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={8}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Typography variant="h6" color="textPrimary">
            Informações de cobrança
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Controller
            name="paymentMethod"
            as={
              <SelectPaymentMethod
                items={constants.paymentMethods.METHODS}
                size="small"
              />
            }
            control={control}
            mode="onBlur"
          />
        </Grid>
        {components?.settings?.inputs?.map((input) => (
          <DynamicInputField
            key={input.id}
            input={input}
            control={control}
            setValue={setValue}
            errors={errors}
          />
        ))}
        {/* Campo hidden para documentType */}
        <Controller
          name="documentType"
          as={<input type="hidden" />}
          control={control}
          mode="onBlur"
        />
      </Grid>
      <Box mt={4}>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          style={{ width: '100%' }}
        >
          CONTINUAR O PAGAMENTO
        </Button>
      </Box>
    </form>
  )
}

export default CustomerForm
